import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AppConfigs } from "config/appConfigs";
import { AuthClientProvider } from "./client";

export interface IPolicyExecutionStatus {
  createdTime: string;
  customStatus: {
    FailedAgreements: number;
    IsWaiting: boolean;
    Message: string;
    PolicyId: string;
    ProcessedAgreements: number;
    SuccessfulAgreements: number;
    TotalAgreements: number;
    WaitingUntil: string | null;
  };
  input: any;
  instanceId: string;
  lastUpdatedTime: string;
  name: string;
  output: string;
  runtimeStatus: string;
}

export function implicitAcceptanceBaseQuery() {
  return fetchBaseQuery({
    baseUrl: AppConfigs().implicitAcceptanceServiceBaseUrl,
    prepareHeaders: async (headers: Headers) => {
      const authClient = AuthClientProvider.getInstance();
      const { scopeImplicitAcceptance } = AppConfigs().authentication;
      const token = await authClient.getAuthenticationToken(scopeImplicitAcceptance);
      
      headers.set("authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  });
}

export const implicitAcceptanceApi = createApi({
  reducerPath: "implicitAcceptanceApi",
  baseQuery: implicitAcceptanceBaseQuery(),
  tagTypes: ["PolicyExecution"],
  endpoints: (builder) => ({
    getPolicyExecutionStatus: builder.query<IPolicyExecutionStatus, string>({
      query: (policyId) => `policy/${policyId}`,
      providesTags: (result, error, policyId) => [{ type: "PolicyExecution", id: policyId }],
    }),
  }),
});

export const { useGetPolicyExecutionStatusQuery } = implicitAcceptanceApi;
